module.exports = __webpack_public_path__ + "static/media/4C.23c51e0b.png";